import { useState } from "react";
import { FaSpinner, FaCheckCircle, FaExclamationCircle } from "react-icons/fa";

export default function ContactForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState(null); // null | 'sending' | 'success' | 'error'

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      const response = await fetch("http://localhost:5000/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus("success");
        setFormData({ name: "", email: "", phone: "", message: "" });

        // Auto-clear success message after 5s
        setTimeout(() => setStatus(null), 5000);
      } else {
        setStatus("error");
      }
    } catch (error) {
      console.error("Error:", error);
      setStatus("error");
    }
  };

  return (
    <div className="max-w-lg mx-auto px-6 py-1 bg-gray-800 rounded-xl">
      <h2 className="text-2xl text-yellow-400 font-semibold text-center mb-5">
        Contact Us
      </h2>

      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          name="name"
          autoComplete="name"
          placeholder="Your Name"
          className={`w-full p-3 border rounded-xl bg-white/20 text-white focus:outline-none ${
            status === "error" && formData.name === "" ? "border-red-600" : "border-yellow-300"
          }`}
          value={formData.name}
          onChange={handleChange}
          required
        />

        <input
          type="email"
          name="email"
          autoComplete="email"
          placeholder="Your Email"
          className={`w-full p-3 border rounded-xl bg-white/20 text-white focus:outline-none ${
            status === "error" && formData.email === "" ? "border-red-600" : "border-yellow-300"
          }`}
          value={formData.email}
          onChange={handleChange}
          required
        />

        <input
          type="tel"
          name="phone"
          autoComplete="tel"
          placeholder="Your Phone Number"
          className={`w-full p-3 border rounded-xl bg-white/20 text-white focus:outline-none ${
            status === "error" && formData.phone === "" ? "border-red-600" : "border-yellow-300"
          }`}
          value={formData.phone}
          onChange={handleChange}
          required
        />

        <textarea
          name="message"
          autoComplete="off"
          placeholder="Your Message"
          rows="5"
          className={`w-full p-3 border rounded-xl bg-white/20 text-white focus:outline-none ${
            status === "error" && formData.message === "" ? "border-red-600" : "border-yellow-300"
          }`}
          value={formData.message}
          onChange={handleChange}
          required
        />

        <button
          type="submit"
          className="w-full py-3 bg-blue-600 hover:bg-yellow-700 text-white font-medium rounded-xl transition flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={status === "sending"}
        >
          {status === "sending" ? (
            <>
              <FaSpinner className="animate-spin" /> Sending...
            </>
          ) : (
            "Send Message"
          )}
        </button>
      </form>

      {/* Status messages */}
      <div className="mt-4 text-center" aria-live="polite">
        {status === "success" && (
          <p className="text-green-500 flex items-center justify-center gap-2">
            <FaCheckCircle /> Message sent successfully!
          </p>
        )}
        {status === "error" && (
          <p className="text-red-500 flex items-center justify-center gap-2">
            <FaExclamationCircle /> Something went wrong. Please try again.
          </p>
        )}
      </div>
    </div>
  );
}
